import React from 'react'
import './about.css'
import ME from '../../assests/about.png'
import {FaAward} from 'react-icons/fa'
import {VscFolderActive} from 'react-icons/vsc'


const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="conatiner about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt=" About Image" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className='about__icon' />
              <h5>Experience</h5>
              <small> 6+ Months </small>
            </article>
            <article className="about__card">
              <VscFolderActive className='about__icon' />
              <h5>Projects</h5>
              <small> 3+ Completed </small>
            </article>
          </div>
          <p>
            <h2>Hello,</h2> 
            I am Prateek, completed my Bachelor's Of Computer Applications from BIT, Mesra. <br />
            Expert in writing responsive and efficient code.  
          </p>
          <a href = "#contact" className='btn btn-primary-about'> Let's Talk </a>
        </div>
      </div>
    </section>
  )
}

export default About